import { createContext, useContext } from "react";
import type { FinishProjectSummary } from "./FinishProjectSummary";

export const SummaryContext = createContext({} as FinishProjectSummary);
export const useSummaryContext = () => useContext(SummaryContext);
